var _circle, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_2102_26020)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1605 18.87C17.0605 18.86 16.9405 18.86 16.8305 18.87C14.4505 18.79 12.5605 16.84 12.5605 14.44C12.5605 11.99 14.5405 10 17.0005 10C19.4505 10 21.4405 11.99 21.4405 14.44C21.4305 16.84 19.5405 18.79 17.1605 18.87Z",
    stroke: "#00AC4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4093 12C26.3493 12 27.9093 13.57 27.9093 15.5C27.9093 17.39 26.4093 18.93 24.5393 19C24.4593 18.99 24.3693 18.99 24.2793 19",
    stroke: "#00AC4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1607 22.56C9.7407 24.18 9.7407 26.82 12.1607 28.43C14.9107 30.27 19.4207 30.27 22.1707 28.43C24.5907 26.81 24.5907 24.17 22.1707 22.56C19.4307 20.73 14.9207 20.73 12.1607 22.56Z",
    stroke: "#00AC4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3398 28C27.0598 27.85 27.7398 27.56 28.2998 27.13C29.8598 25.96 29.8598 24.03 28.2998 22.86C27.7498 22.44 27.0798 22.16 26.3698 22",
    stroke: "#00AC4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2102_26020",
    x1: 35.5,
    y1: 0.00000101998,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFFF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountIcon);
export default __webpack_public_path__ + "static/media/CountIcon.ddfde8bb7ef7db2edf17744778122af8.svg";
export { ForwardRef as ReactComponent };